import React from 'react'
import Box from '../components/styled-system/Box'
import Heading from '../components/styled-system/Heading'
import Text from '../components/styled-system/Text'
import Container from '../components/styled-components/Container'

function Hero (props) {
  return (
    <Box as='header' p={['4', '6']} bg='hsl(0, 0%, 98%)'>
      <Container>
        <Heading as='h1' fontSize={['6', '7']} lineHeight='44px' textAlign='center' maxWidth='25ch' marginLeft='auto' marginRight='auto'>{props.title}</Heading>
        {props.subtitle &&
        <Box fontSize={['2', '4']} maxWidth={['65ch']} m='0 auto'>
          <Text textAlign='center' color='grey' mt={['3', '4']}>{props.subtitle}</Text>
        </Box>
        }
      </Container>
    </Box>
  )
}

Hero.defaultProps = {
  title: '',
  subtitle: ''
}

export default Hero
